import { render, staticRenderFns } from "./OfferCartMobileWeek.vue?vue&type=template&id=63ce5425&"
import script from "./OfferCartMobileWeek.vue?vue&type=script&lang=js&"
export * from "./OfferCartMobileWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports